import React from 'react';
import ReloadButton from '../../../../../features/ReloadButton/ReloadButton';
import { InputFieldSearch, SelectOption, addOption } from '../../../../../utils/InputField';
import { useBillingUnauthorized } from '../UnauthorizedListProvider';

function PageHeaderLeftCol({ p, onChangeHandler }) {
    const statusArr = [
        {
            key: 'paid',
            value: 'Paid'
        },
        {
            key: 'due',
            value: 'due'
        },
        {
            key: 'partial_paid',
            value: 'Partial Paid'
        },
        {
            key: 'canceled',
            value: 'Canceled'
        }
    ];
    return (
        <div
            // onSubmit={handleOnEnter}
            className="customers_page_header_left_col flex-1 flex flex-row items-center gap-x-2 md:gap-x-4"
        >
            <InputFieldSearch
                label="Search by id or invoice title or customer...."
                name="q"
                onChange={onChangeHandler}
                formData={p}
                className="w-72"
            />

            <SelectOption
                name="status"
                placeholder="Status"
                formData={p}
                onChange={onChangeHandler}
                options={statusArr?.map((d) => addOption(d.key, d.value, d.key))}
                className="w-38 hidden"
            />
        </div>
    );
}

function PageHeaderRightCol() {
    const { handleReload } = useBillingUnauthorized();
    return (
        <div className="customer_page_header_right_col flex-1 flex flex-row gap-2 justify-end items-center ">
            <ReloadButton height="h-10" width="w-10" onClick={handleReload} />
        </div>
    );
}

function UnauthorizedListPageHeader({ p, onChangeHandler }) {
    return (
        <div className="customer_page_header w-full mb-3 md:mb-7 flex flex-row justify-between items-center">
            <PageHeaderLeftCol p={p} onChangeHandler={onChangeHandler} />
            <PageHeaderRightCol />
        </div>
    );
}

export default UnauthorizedListPageHeader;
